const doc = [({"da":({"js":({"components":({"school_classes":({"table":({"administrators":"Administratorer"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;